import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslationService} from './services/translation/translation.service';
import { AfMessageService } from './services/translation/afMessage.service';
import { MessageService } from '@progress/kendo-angular-l10n';

@Component({
  selector: 'af-root',
  imports: [
    RouterOutlet,

  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ { provide: MessageService, useClass: AfMessageService } ]
})
export class AppComponent {
  title = 'autoform-customer-portal-frontend';

  constructor(private translatorService: TranslationService) {
    this.translatorService.initLanguage();
  }
}
